"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ErrorMessages = _interopRequireDefault(require("../ErrorMessages"));

var _descriptionMessagesProps = require("./descriptionMessagesProps");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DescriptionMessages = function DescriptionMessages(_ref) {
  var description = _ref.description,
      descriptionId = _ref.descriptionId,
      descriptionUniqueId = _ref.descriptionUniqueId,
      errorMessages = _ref.errorMessages,
      isDescriptionHtml = _ref.isDescriptionHtml,
      isDisabled = _ref.isDisabled,
      isValid = _ref.isValid;
  var descriptionStyles = (0, _classnames.default)('form-control__description', {
    'form-control__description--error': !isValid,
    'form-control__description--disabled': isDisabled
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    id: descriptionId || descriptionUniqueId,
    className: descriptionStyles,
    "data-testid": "descriptionMessages"
  }, errorMessages && errorMessages.length > 0 && !isValid && /*#__PURE__*/_react.default.createElement(_ErrorMessages.default, {
    errorMessages: errorMessages,
    isValid: isValid
  }), description && isDescriptionHtml ? description.props.children : description && /*#__PURE__*/_react.default.createElement("p", {
    className: "form-control__description-content"
  }, description));
};

DescriptionMessages.defaultProps = _descriptionMessagesProps.DescriptionMessagesDefaultProps;
DescriptionMessages.propTypes = _descriptionMessagesProps.DescriptionMessagesPropTypes;
var _default = DescriptionMessages;
exports.default = _default;